import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['sourceInput', 'destinationInput']

  copy(event) {
    event.preventDefault()

    if (event.currentTarget.checked) {
      this.sourceInputTargets.forEach((sourceInput) => {
        const destinationInput = this.destinationInputTargets.find((input) => {
          const sourceAttribute = sourceInput.dataset.copyAttribute
          const destinationAttribute = input.dataset.copyAttribute
          return sourceAttribute === destinationAttribute
        })

        destinationInput.value = sourceInput.value
      })
    }
  }
}
